import classNames from 'clsx';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import type { EventBasedMarketView } from '@swf/generated/types/api/sports';
import type { EventTypeId } from '@swf/sports/types/eventType';
import { getMarketRunners } from '@swf/sports/utils/useMarketHeadersFromEvents';

import styles from './Header.scss';

export interface Props {
  market: EventBasedMarketView;
  eventTypeId: EventTypeId;
}

const Header: React.FC<Props> = ({ market, eventTypeId }) => {
  const { marketName, marketType, runners } = market;
  const runnerHeadings = getMarketRunners(marketType, market.runners, eventTypeId);
  if (!marketName && !runners.length) return null;

  return (
    <div
      data-testid="market-template-header"
      className={classNames(styles.header, {
        [styles.twoRunnerMarket]: runners.length === 2,
        [styles.threeRunnerMarket]: runners.length === 3
      })}
    >
      <span>{marketName}</span>
      <div className={styles.runners}>
        {runnerHeadings.map((runner, i) => {
          if (typeof runner === 'string') {
            return <span key={`${runner}-${i}`}>{runner}</span>;
          }
          return (
            <span key={`${runner.id}-${i}`}>
              <Translation {...runner} />
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default Header;
